(function ($, window) {
    'use strict';
    $(document).ready(function ($) {

        $('body').on('click', '[data-location-id]', function(){
            let elem = $(this);
            let location = {
                id: elem.data('location-id'),
                name: elem.data('location-name'),
            };
            // Flag to determine if a link click is local or external.
            window.localLinkClicked = false;
            if(location.id === 0){
                window.location.href = getUrl('cms/redirect-default');
            }else{
                window.location.href = getUrl(location.name);
            }
        });

        $('#locations-filter-query').on('input change', function(){
            let locationsElem = $('[data-location-name]');
            let search = $(this).val();

            if(search === null || search === ''){
                locationsElem.removeClass('hide');
                return;
            }

            let substrRegex = new RegExp(search, 'i');
            let fitered = [];
            locationsElem.each(function(){
                let locationElem = $(this);
                let name = locationElem.data('location-name');
                locationElem.toggleClass('hide', !substrRegex.test(name));
            });

            $('.location-filter-no-result').toggleClass('hide', !(locationsElem.not(".hide").length === 0));
        });
    });
})(jQuery, window);